import React from 'react';
import {connect} from 'react-redux'

import {getBaseArticlePrice, getCartSummary} from '../../selectors/Cart'
import {isSimpleSummaryValid} from "../../selectors/StepValidation";
import SummaryTotalListing from "../../components/summary/SummaryTotalListing";


function SimpleSummary(props) {

    return (
        <div className={`simple-summary ${props.isValidSummary ? '' : 'invalid'}`}>
            <SummaryTotalListing cartSummary={props.cartSummary}/>
        </div>
    );

}

SimpleSummary.propTypes = {};

const mapStateToProps = (state) => {

    return {
        cartSummary: getCartSummary(state),
        isFetching: state.cart.isFetching,
        baseArticlePrice: getBaseArticlePrice(state),
        isValidSummary: isSimpleSummaryValid(state),
        forcedValidationSteps: state.ui.forcedValidationSteps
    }

}


const mapDispatchToProps = (dispatch, getState) => {

    return {}

}

export default connect(mapStateToProps, mapDispatchToProps)(SimpleSummary)



/** WEBPACK FOOTER **
 ** ./src/containers/clientdatasimple/SimpleSummary.js
 **/